module.exports = __webpack_public_path__ + "static/media/No_image.8906ed77.webp";